import React from 'react';
import { Button } from 'antd';
import { MdFilterListOff } from 'react-icons/md';
import { Trans } from 'react-i18next';
import styles from '../ChatsList.module.scss';
export var DropdownOptions;
(function (DropdownOptions) {
    DropdownOptions["RESOLVE_CHATS"] = "resolveChats";
})(DropdownOptions || (DropdownOptions = {}));
const dropdownMenu = ({ agents, departments, labels, resetFilters, filtersApplied, }) => {
    const menu = () => {
        const items = [
            {
                key: 'header',
                style: { pointerEvents: 'none' },
                className: styles.noHoverMenuItem,
                label: (React.createElement("div", { className: styles.dropdownHeader },
                    React.createElement("span", null,
                        "Filters applied: ",
                        React.createElement("span", { className: styles.count }, filtersApplied)),
                    resetFilters && (React.createElement("div", { style: { pointerEvents: 'auto' } },
                        React.createElement(Button, { onClick: resetFilters, type: "default", icon: React.createElement(MdFilterListOff, null), className: styles.clearAllButton, danger: true, size: "small" },
                            React.createElement(Trans, { i18nKey: "clearAllFilters" })))))),
            },
            {
                key: 'departments',
                style: { pointerEvents: 'none' },
                className: styles.noHoverMenuItem,
                label: (React.createElement("div", { className: styles.dropdownItemWrapper },
                    React.createElement("span", null,
                        React.createElement(Trans, { i18nKey: "department" }),
                        ":"),
                    React.createElement("div", { style: { pointerEvents: 'auto' } }, departments))),
            },
            {
                key: 'agents',
                style: { pointerEvents: 'none' },
                className: styles.noHoverMenuItem,
                label: (React.createElement("div", { className: styles.dropdownItemWrapper },
                    React.createElement("span", null,
                        React.createElement(Trans, { i18nKey: "agent" }),
                        ":"),
                    React.createElement("div", { style: { pointerEvents: 'auto' } }, agents))),
            },
            ...(labels ? [{
                    key: 'labels',
                    style: { pointerEvents: 'none' },
                    className: styles.noHoverMenuItem,
                    label: (React.createElement("div", { className: styles.dropdownItemWrapper },
                        React.createElement("span", null,
                            React.createElement(Trans, { i18nKey: "labels" }),
                            ":"),
                        React.createElement("div", { style: { pointerEvents: 'auto' } }, labels))),
                }] : []),
        ];
        return { items: items.filter(Boolean) };
    };
    return menu();
};
export default dropdownMenu;
